export const DEBOUNCE = 'debounce';
export const TAKE_LATEST = 'takeLatest';
export const THROTTLE = 'throttle';
